import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/da2i7paamq5jpe1hrtk0";

type Status = "idle" | "loading" | "success" | "error";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (status === "loading") return;

    // Honeypot: simula sucesso silenciosamente
    if (honeypot.trim() !== "") {
      setStatus("success");
      setMessage("Inscrição confirmada!");
      setEmail("");
      return;
    }

    const trimmed = email.trim();
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
    if (!emailOk) {
      setStatus("error");
      setMessage("Digite um e-mail válido.");
      return;
    }

    setStatus("loading");
    try {
      const body = new URLSearchParams();
      body.append("email", trimmed);
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message ?? "";
      if (!res.ok || parsed?.code !== "OK" || /spam/i.test(serverMsg)) {
        throw new Error(serverMsg || "Falha no envio");
      }
      setStatus("success");
      setMessage("Inscrição confirmada!");
      setEmail("");
    } catch {
      setStatus("error");
      setMessage("Algo deu errado. Tente novamente.");
    }
  };

  return (
    <section className="w-full px-4 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto bg-primary-50/80 rounded-3xl px-6 md:px-12 py-12 md:py-14 text-center border border-primary-100">
        <h3 className="font-heading text-2xl md:text-[34px] text-foreground-950 font-medium leading-tight">
          Newsletter
        </h3>
        <p className="text-sm text-foreground-700 mt-3 max-w-md mx-auto">
          Novidades e bastidores do ateliê, duas vezes por mês.
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          id="newsletter-form"
          className="mt-7 flex flex-col sm:flex-row gap-2.5 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            required
            placeholder="Seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 h-12 px-5 rounded-full bg-background-50 border border-background-300/70 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 transition"
          />
          {/* Honeypot */}
          <div className="field-extra-input" aria-hidden="true">
            <label>
              Website
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                value={honeypot}
                onChange={(e) => setHoneypot(e.target.value)}
              />
            </label>
          </div>
          <button
            type="submit"
            disabled={status === "loading"}
            className="h-12 px-7 rounded-full bg-primary-500 hover:bg-primary-600 disabled:bg-primary-400 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            {status === "loading" ? "..." : "Assinar"}
          </button>
        </form>

        {status !== "idle" && status !== "loading" && (
          <p
            className={`mt-4 text-[13px] ${
              status === "success" ? "text-accent-700" : "text-primary-700"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}